<template>
  <div class="SituationCard" @click="handleGotoSituationTransition({situationID: situation.id})">
    <img class="sc-thumbnail" :src="publicPath+'/media'+mediaURL+'/'+situation.name.trim()+'.'+thumbnailType" alt="" :class="{'sc-thumbnail-highlight': currentSituationID == situation.id}">
    <span class="sc-name">{{situation.name}}</span>
  </div>
</template>

<script>
import {mapGetters,mapMutations} from 'vuex';

export default {
  props: ['situation'],
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  methods:{
    ...mapMutations(["handleGotoSituationTransition"])
  },
  computed: {
    ...mapGetters(["mediaURL","panoramaTour",'thumbnailType','currentSituationID'])
  },
}
</script>

<style scoped>
.SituationCard{
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.sc-thumbnail{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 6px solid transparent;
  transition: .1s border-color;
}
.sc-thumbnail:hover{
  border-color: var(--primaryColor);
}
.sc-thumbnail-highlight{
  border-color:var(--secondaryColor);
}
.sc-name{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.342);
  color: white;
  padding: 10px;
  font-size: 18px;
  text-align: center;
}
</style>